<template>
	<div>

		<!-- <div>
			<table-filter :filters="filters" @onFilter="onFilterLocal" @onClear="clearFilters"></table-filter>
		</div> -->

		<FiltersTable titleButton="Obtener órdenes" searchPlaceholder="Buscar por 'Órden ML'" @onSearch="onSearch"/>

		<div v-if="showDetailsModal">
        <OrderDetails :orderDetail="orderDetails" @orderDetail="handleOrderDetails" />
    </div>
		
		<VxTable 
			stripe
			:data="orders" 
			pagination 
			:max-items="30"
			:total="totalItems"
			:sst="true" 
			@change-page="handleChangePage">
			
			<template slot="thead">
				<vs-th style="min-width: 80px">Órden ML</vs-th>
				<vs-th style="min-width: 80px">NIC</vs-th>
				<vs-th style="min-width: 100px">Destinatario</vs-th>
				<!-- <vs-th style="min-width: 80px">Comprador</vs-th> -->
				<vs-th style="min-width: 90px">Valor</vs-th>
				<vs-th style="min-width: 110px">Fecha</vs-th>
				<vs-th style="min-width: 130px">Actualizada</vs-th>
				<vs-th style="min-width: 70px">Modo</vs-th>
				<vs-th style="min-width: 90px">Status CDS</vs-th>
				<vs-th style="min-width: 60px">Acción</vs-th>
			</template>

			<template slot-scope="{data}">
				<vs-tr :key="indextr" v-for="(tr, indextr) in data" >
					<vs-td>
						{{ tr.id }} 
					</vs-td>
					<vs-td>
						{{tr.cds_nic}}
					</vs-td>
					<vs-td>
						Cuenta: <em>{{tr.buyer.first_name}} {{tr.buyer.last_name}} ({{tr.buyer.nickname}}).</em> <br>
						Recibe:  <em>{{tr.shipment_data.receiver_address.receiver_name}} </em>
					</vs-td>
					<!-- <vs-td>
						{{tr.buyer.billing_info.doc_number}}
					</vs-td> -->
					<vs-td>
						$ {{tr.total_amount}}
					</vs-td>
					<vs-td>
						{{ data[indextr].date_created | formatDate }}
					</vs-td>
					<vs-td>
						{{ data[indextr].last_updated | formatDateFromNow }}
					</vs-td>
					<vs-td>
						{{tr.shipment_data.mode | translateShipmentMode }}
					</vs-td>
					<vs-td>
						{{tr.shipment_data.status | translateStatus}}
					</vs-td>
					<!-- <vs-td>
						{{tr.buyer.billing_info.doc_number}}
					</vs-td> -->
					<vs-td>
						<!-- <vs-button type="border" size="small" color="primary" class="mr-2" 
							@click="openPopupDetalle(data[indextr])">
							<feather-icon icon="SearchIcon" svgClasses="h-2 w-2"/>
							Detalle
						</vs-button> -->
						<feather-icon @click="openDetails(tr)" icon="EyeIcon" svgClasses="h-5 w-5 mx-1 cursor-pointer" />
					</vs-td>
				</vs-tr>
			</template>

		</VxTable>

	</div>
</template>

<script>
// Extraer: 
// MOMENTJS and CONFIG
// AXIOS and CONFIG
// FILTERS 
import _ from 'lodash'// ya esta improtado en archivo local pero si no lo improto aca da errores aveces

import moment from 'moment'
moment.locale('es')

import axios from 'axios';
axios.defaults.withCredentials = true;

import OrderDetails from "../../components/modals/Orders/OrderDetails.vue";
import FiltersTable from "../../components/filters-table/FiltersTable.vue"

export default {
	components: {
		OrderDetails,
		FiltersTable
	},
	data(){
		return {
			orders: [],
			ordersPreserved:[], // used when reseting local filtering
			totalItems: 0,
			selected: [], // Los items seleccionados con el checkbox 
			
			// Popup (detalle & proccesar)
			popupOrder: {}, // El item en que se ha clickeado Detalle o Procesar
			popupOrderShipmentInfo: null,

			// Popup - detalle
			popupDetalleActive: false,

			filtersSelected: [],

			orderDetails: {},
			showDetailsModal: false,

		}
	},

	filters : {
		formatDate(rawDate){
			return moment(rawDate).format("D-M-Y");
		},
		formatDateFromNow(rawDate){
			return moment(rawDate).fromNow();
		},
		translateShipmentMode(mode){
			let modesMap = {
				'not_specified': 'Acuerdo con el vendedor',
				'custom': 'Envio Custom',
				'me1': 'Mercado Envíos 1',
				'me2': 'Mercado Envíos 2',
			}

			return modesMap[mode] ? modesMap[mode] : '';
		},
		translateStatus(status){
			let modesMap = {
				"shipped": "En Viaje",
				"delivered": "Entregado",
				"cancelled": "Rechazado",
				"not_delivered": "Con problemas en entrega",
				"pending": "Pendiente",
			}

			return modesMap[status] ? modesMap[status] : '';
		}
	},


	mounted() {
		this.loadOrders();		
	},

	methods: {
		loadOrders(page = 1) {
			this.$vs.loading();

			this.filtersSelected['page'] = page;

			try {
				const filtersSelected = this.filtersSelected;
				const query = Object.keys(filtersSelected)
				.map(key => encodeURIComponent(key) + '=' + encodeURIComponent(filtersSelected[key]))
				.join('&');

				axios.get(process.env.VUE_APP_BACKEND_URL + 'api/orders-processed?' + query)
				.then(orders => {
					console.log(orders.data);

					if (orders.data.body) {
					this.orders = orders.data.body;
					this.ordersPreserved = orders.data.body;
					}
					if (orders.data.paging.total) {
					this.totalItems = orders.data.paging.total;
					}
					if (!orders.data.body) {
					console.log("est Vaccio");
					}
				})
				.catch(e => {
					console.log(e);
				})
				.finally(() => {
					this.$vs.loading.close();
				});

			} catch (e) {
				console.log(e);
				this.$vs.loading.close(); 
			}
		},

		onSearch(value){
			this.filtersSelected = value;
			this.loadOrders(1);
		},

		handleChangePage (page) {
			this.loadOrders(page)
		},

		// NEW METHODS FOR ACTIONS
		openDetails(tr) {
			this.orderDetails = tr;
			this.showDetailsModal = true;
		},
		handleOrderDetails() {
			this.showDetailsModal = false;
		},

	}
}
</script>